import { mapActions } from 'vuex';
<!-- eslint-disable prettier/prettier -->
<template>
  <div class="w-full h-[calc(100vh-10rem)]">
    <!-- -->
    <div class="text-left font-semibold text-xl pb-2">Chat section</div>
    <div class="flex justify-center items-center w-full">
      <div
        class="w-[90%] bg-input-search rounded-full flex justify-center items-center"
      >
        <el-input
          v-model="valueSearchMessage"
          size="large"
          placeholder="Please Input"
          :prefix-icon="Search"
        />
      </div>
    </div>

    <div class="flex items-center w-full pt-3 pb-3">
      <button class="pad-btn rounded-full active-btn">
        <span class="font-text-default">Mailbox</span>
      </button>
    </div>

    <div class="flex items-center">
      <div
        class="w-full h-[38rem] overflow-y-auto hide-scroll"
        v-if="renderListChannels.length !== 0"
      >
        <div
          class="w-full flex justify-between items-center cursor-pointer pl-1 pr-1 text-hover"
          v-for="(item, index) in renderListChannels"
          @click="onClickMessage(item)"
          :key="index"
        >
          <div class="w-[50px]">
            <div
              :style="{
                'background-image': `url(${
                  item.clients[1]
                    ? item.clients[1].profiles?.avatars[0]?.meta.url
                    : imageDefault
                })`,
              }"
              class="rounded-full size-image-small"
            ></div>
          </div>
          <div class="pt-3 pb-3 w-[calc(100%-50px)] text-left">
            <div class="font-semibold text-base" v-if="item.clients[1]">
              {{ item.clients[1].fullname }}
            </div>
            <div v-else class="font-semibold text-base">Tài khoản bị xóa</div>
            <div
              class="font-medium text-sm text-ellipsis overflow-hidden whitespace-nowrap"
            >
              {{ item.lastMessage.message.text }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="w-full">
        <div class="flex justify-center items-center w-full">
          <div
            class="imgMes"
            :style="`background-image: url('${imgMessage}');`"
          ></div>
        </div>
        <div class="w-full text-center">
          <div class="text-title">There are no messages</div>
          <div class="text-description">New messages will appear here</div>
        </div>
      </div>
    </div>

    <!--  -->
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "form-message-view",

  data() {
    return {
      valueSearchMessage: "",
      imgMessage: require("../../../assets/icon_svg/ic_mes_default.png"),
    };
  },

  computed: {
    renderListChannels() {
      return this.$store.state.messageModule.listChanelIds;
    },
  },

  mounted() {},

  methods: {
    ...mapActions(["getListMessageChanel"]),
    ...mapMutations(["setListMessageSelected", ""]),
    async onClickMessage(val) {
      await this.getListMessageChanel({
        chanelId: val.channelId,
        pageSize: 50,
        currentPage: 0,
      }).then((data) => {
        // Xét giá trị cho Mutation: để show popup nhắn tin
        this.setListMessageSelected({
          idChannel: val.channelId,
          dataClient: data.clients,
          isShowForm: true,
          dataMessages: data.list_data,
        });

        this.$emit("onShowFormChat", true);
      });
    },
  },
};
</script>

<style lang="scss">
.imgMes {
  width: 100px;
  height: 100px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
